import { MANAGE_TABLE } from "app/ManageTables/types";
import { FETCH_SUCCESS } from "app/RestaurantProducts/types";
import { tableResponse, tableUpdate } from "helpers/reducers";
import { AnyAction } from "redux";
import { IGPTable } from "ui/Table/Table";
import { RESTAURANT_PRODUCTS_TABLE_UPDATE } from "../types";

function ConnectRestaurantProductsTable(
    state: IGPTable = {
        id: "ConnectRestaurantProductsTable",
        elasticSearch: true,
        columns: [],
        availableColumns: [],
        pagination: {
            page: 1,
            per_page: 20,
            isLastPage: true,
            total: 0,
        },
        search: "",
        filterData: [],
        filterSettings: {
            open: false,
            total: 0,
        },
        filters: {},
        sort: { name: "asc" },
        with: [],
    },
    action: AnyAction
) {
    switch (action.type) {
        case FETCH_SUCCESS:
            if (action.response.config.params._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;
        case MANAGE_TABLE:
            if (action.data.id === state.id) {
                return {
                    ...state,
                    ...action.data,
                };
            }
            return state;
        case RESTAURANT_PRODUCTS_TABLE_UPDATE:
            return tableUpdate(state, action);
        default:
            return state;
    }
}

export default ConnectRestaurantProductsTable;
